import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../pages/admin/admin_assets/css/common.css';
import axios from 'axios';
import config from '../../../config/config.js';

function Categories() {
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);

  // Fetch Categories
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.API_BASE_URL}/get_categories.php`);
      const data = response.data;
      if (data.success) {
        setCategories(data.categories);
      } else {
        toast.error(data.message || 'Failed to fetch categories.');
      }
    } catch (error) {
      toast.error('An error occurred while fetching categories.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle Category Input Change
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  // Submit (Create/Update) Category
  // Submit (Create/Update) Category
const handleSubmit = async () => {
  if (!category.trim()) {
    toast.error('Please enter a category.');
    return;
  }
  try {
    let response;
    if (isEditing) {
      // Update Category (PUT)
      response = await axios.put(`${config.API_BASE_URL}/category.php`, {
        id: editCategoryId,  // Make sure id is passed here
        name: category,
      });
    } else {
      // Create Category (POST)
      response = await axios.post(`${config.API_BASE_URL}/category.php`, {
        name: category,
      });
    }

    const data = response.data;
    if (data.success) {
      toast.success(`Category "${category}" ${isEditing ? 'updated' : 'created'} successfully!`);
      setCategory('');
      setIsEditing(false);
      setEditCategoryId(null);
      fetchCategories(); // Refresh the category list
    } else {
      toast.error(data.message || 'Failed to submit category.');
    }
  } catch (error) {
    toast.error('An error occurred while submitting the category.');
  }
};

// Delete Category
// Delete Category
const handleDelete = async (id) => {
  try {
    const response = await axios.delete(`${config.API_BASE_URL}/category.php`, {
      data: { id: id },  // Send the category ID in the request body
    });
    const data = response.data;
    if (data.success) {
      toast.success('Category deleted successfully!');
      setCategories(categories.filter((category) => category.id !== id)); // Remove deleted category from the list
    } else {
      toast.error(data.message || 'Failed to delete category.');
    }
  } catch (error) {
    toast.error('An error occurred while deleting the category.');
  }
};


  // Edit Category
  const handleEdit = (category) => {
    setIsEditing(true);
    setEditCategoryId(category.id);
    setCategory(category.name);
  };

  return (
    <>
      <div className="container-fluid category_form_sec">
        <div className="category_input_wrapper mt-5">
          <div className="mb-3" style={{ width: '33%' }}>
            <h1 className="dashboard_heading">Create Categories</h1>

            <input
              type="text"
              className="form-control"
              placeholder="Enter Category Name"
              id="categoryInput"
              value={category}
              onChange={handleCategoryChange}
              style={{ marginBottom: '10px' }}
            />
            <Button onClick={handleSubmit} className="exportbutton">
              {`${isEditing ? 'Update' : 'Create'}`}
            </Button>
          </div>
        </div>
        <div className="table-container px-0">
          {loading ? (
            <p>Loading categories...</p>
          ) : (
            <form>
              <table className="table">
                <thead>
                  <tr>
                    <th>Category Name</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.length > 0 ? (
                    categories.map((category, index) => {
                      const formattedDate = new Date(category.created_at).toLocaleDateString(); // Format date
                      return (
                        <tr key={category.id || index}>
                          <td>{category.name}</td>
                          <td>{formattedDate}</td>
                          <td>
                            <div className="action_btn">
                              <div
                                className=""
                                style={{ marginRight: '20px', color: '#0d6efd' }}
                                onClick={() => handleEdit(category)}
                              >
                                Edit
                              </div>
                              <div
                                className=""
                                style={{ color: '#dc3545' }}
                                onClick={() => handleDelete(category.id)}
                              >
                                Delete
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="3">No categories available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </form>
          )}
        </div>

        <ToastContainer />
      </div>
    </>
  );
}

export default Categories;
